'use client';

import { Link } from 'react-router-dom';
import styles from '../ProductDetail.module.css';

export function AkustikYumurtaSungerHubContent() {
  return (
    <div className={styles.seoWrap}>
      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Nedir?</h2>
        <p className={styles.seoText}>
          Akustik yumurta sünger, yüzeyi yarım küre şeklinde yumurta deseniyle işlenmiş açık hücreli ses
          emici bir malzemedir. Kapalı alanlarda oluşan yankıyı, çınlamayı ve ses yansımalarını azaltmak
          için kullanılır. Poliüretan esaslı üretilir. Yumurta profili ses dalgasını dağıtarak geniş
          frekans bandında emilim sağlar. Düz yüzeyli panellere kıyasla daha yumuşak ve dengeli bir
          akustik karakter sunar.
        </p>
        <p className={styles.seoText}>
          BariyerliBondexSunger.com olarak Echopan markasıyla sunduğumuz yumurta akustik sünger modelleri
          stüdyo, podcast odası, ev sinema ve ofis projelerinde yaygın olarak tercih edilir. Ürün oda içi
          akustik düzenleme sağlar. Komşu odadan gelen sesi engellemez. Ses geçişi için{' '}
          <Link to="/bondex-sunger" rel="follow">
            Bondex sünger
          </Link>{' '}
          gibi yalıtım malzemeleri ayrıca değerlendirilmelidir.
        </p>
        <p className={styles.seoText}>
          Yumurta sünger duvar ve tavana uygulanır. Siyah ve koyu gri tonlarda üretilir. Yangına dayanıklı
          E sınıfı sertifikaya sahiptir. Stoklarımızda 20 ile 50 mm arası kalınlık seçenekleri mevcuttur.
          Standart plaka ölçüsü 100x100 cm dir. Fiyat metrekare başına 320 TL dir.
        </p>
        <p className={styles.seoText}>
          Akustik yumurta sünger ses yalıtım malzemesi değildir. Duvar arkasına yerleştirilerek komşu
          sesi kesilmez. Oda içi yüzeye yapıştırıldığında yankı azalır. Bu ayrım doğru ürün seçiminin
          temelidir.
        </p>

        <h3 className={styles.seoSubtitle}>Yumurta desenli akustik süngerin özellikleri</h3>
        <p className={styles.seoText}>
          Yumurta desenli akustik sünger açık hücreli gözenek yapısına sahiptir. Yoğunluk genelde 25 ile
          35 kg/m³ aralığındadır. NRC değeri 0.80 ve üzeridir. Yarım küre çıkıntıları ses dalgasını
          farklı yönlere yönlendirir ve gözenekli yapıda emer. Malzeme hafiftir, kolay kesilir ve monte
          edilir.
        </p>
        <p className={styles.seoText}>
          Echopan üretim hattında her parti kalınlık ve yoğunluk açısından kontrol edilir. Kesim kenarları
          düzgündür. Kendinden yapışkanlı versiyon sipariş edilebilir. TS EN 13501-1 standardına göre E
          sınıfı yanmazlık belgesi mevcuttur. Ticari projelerde sertifika talep edildiğinde paylaşılır.
        </p>
        <p className={styles.seoText}>
          Yumurta profili stüdyo duvarlarında yaygın tercih edilen yüzeylerden biridir. Piramide göre daha
          yumuşak görünüm sunar. Toz tutmaz yapıdadır. Uzun vadede performans kaybı yaşanmaz. Maket bıçağı
          ile özel şekil ve köşe detayları hızlıca hazırlanır.
        </p>

        <h3 className={styles.seoSubtitle}>Yüzey formunun akustik performansa katkısı</h3>
        <p className={styles.seoText}>
          Yumurta yüzey formu ses dalgasını dairesel desen üzerinde dağıtır. Düz yüzeyde ses tek düzlemde
          yansır. Yumurta çıkıntıları sesi farklı açılardan emer. Orta ve yüksek frekanslarda güçlü
          performans verir. Geniş frekans bandında dengeli çalışır.
        </p>
        <p className={styles.seoText}>
          Yumurta derinliği emilim karakterini etkiler. Derin yumurta deseni daha agresif emilim sağlar.
          Sığ yumurta daha hafif görünüm sunar. Stüdyo kontrol odasında orta derinlik, kayıt odasında
          yoğun kaplama tercih edilir. Teknik ekibimiz oda hacmine göre öneri sunar.
        </p>
        <p className={styles.seoText}>
          Üç boyutlu yarım küre yapısı sesin tek noktada toplanmasını engeller. Bu nedenle podcast ve
          yayın stüdyolarında yumurta profil sık tercih edilir. İlk yansıma noktalarında etkili çalışır.
        </p>

        <h3 className={styles.seoSubtitle}>Diğer akustik sünger modellerinden farkı</h3>
        <p className={styles.seoText}>
          Genel{' '}
          <Link to="/akustik-sunger" rel="follow">
            akustik sünger
          </Link>{' '}
          kategorisinde piramit, yumurta, labirent ve düz profiller bulunur. Yumurta profil yumuşak
          görünümüyle stüdyo ve podcast odalarında öne çıkar.{' '}
          <Link to="/akustik-piramit-sunger" rel="follow">
            Akustik piramit sünger
          </Link>{' '}
          daha keskin geometrik görünüm sunar.{' '}
          <Link to="/akustik-labirent-sunger" rel="follow">
            Labirent akustik sünger
          </Link>{' '}
          geniş tavan uygulamalarında tercih edilir.
        </p>
        <p className={styles.seoText}>
          Piramit ve yumurta emilim performansı birbirine yakındır. Seçim çoğunlukla estetik kaygıya
          dayanır. Düz sünger ekonomik kaplama sağlar. Yumurta profil görsel olarak daha düzenli ve yumuşak
          bir desen oluşturur. Kamera önünde stüdyo görünümü için yumurta sık tercih edilir.
        </p>
        <p className={styles.seoText}>
          Bondex sünger ve yumurta akustik sünger farklı amaçlara hizmet eder. Bondex duvar karkası içinde
          ses geçişini azaltır. Yumurta sünger oda içi yüzeyde yankıyı kontrol eder. Aynı projede ikisi
          birlikte kullanılabilir.
        </p>
        <p className={styles.seoText}>
          Stüdyo projelerinde duvarlara yumurta, tavana labirent panel kombinasyonu uygulanabilir. Her
          profil farklı frekans karakteristiği sunar. Tek profil ile tüm yüzeyi kaplamak zorunlu değildir.
          Teknik ekibimiz profil kombinasyonu önerir.
        </p>
        <p className={styles.seoText}>
          Yanlış ürün seçimi en sık akustik süngeri duvar arkasına koyarak komşu sesini kesmeye çalışmaktır.
          Bu uygulama beklenen sonucu vermez. Yumurta sünger oda içi yüzeyde yankıyı azaltır. Komşu sesi
          için bondex veya bariyerli bondex değerlendirilmelidir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Nerelerde Kullanılır?</h2>
        <p className={styles.seoText}>
          Yumurta akustik sünger yankı kontrolü gereken her kapalı alanda kullanılabilir. Stüdyo ve
          podcast uygulamalarında ilk tercih olur. Mekanın boyutu ve kullanım amacı kaplama planını
          belirler.
        </p>

        <h3 className={styles.seoSubtitle}>Müzik stüdyoları</h3>
        <p className={styles.seoText}>
          Müzik stüdyolarında yumurta sünger duvar ve tavan uygulamalarında kullanılır. Mikrofon oda
          içindeki her yansımayı yakalar. Yumurta panel reverberasyon süresini kısaltır. Kontrol odasında
          doğru miks kararı için dengeli akustik ortam şarttır.
        </p>
        <p className={styles.seoText}>
          Stüdyo projelerinde tüm yüzeyi kaplamak her zaman doğru değildir. İlk yansıma noktaları ve arka
          duvar önceliklidir. Echopan teknik ekibi stüdyo metrajınıza göre kaplama oranı hesaplar. Mirror
          point hesabı ile yerleşim planı oluşturulur.
        </p>
        <p className={styles.seoText}>
          Vokal kayıt odasında arka duvar tamamen kaplanabilir. Enstrüman kaydında daha az kaplama tercih
          edilir. Davul odası ayrı planlanır. Yumurta panel yüksek ses seviyesine dayanıklıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Ses kayıt odaları</h3>
        <p className={styles.seoText}>
          Ses kayıt odalarında yankısız ortam şarttır. Yumurta sünger duvar uygulamasıyla yansımalar
          kontrol altına alınır. Vokal ve enstrüman kayıtlarında oda tonu düşer. Post prodüksiyonda EQ
          düzeltmesine daha az ihtiyaç duyulur.
        </p>
        <p className={styles.seoText}>
          Kayıt odasında arka duvar tamamen kaplanabilir. Köşelere bass trap eklenerek düşük frekanslar da
          hedeflenir. Yumurta panel tek başına bas frekansı ememez. Küçük kayıt odalarında yüzde 30-40
          kaplama oranı yeterli olabilir.
        </p>
        <p className={styles.seoText}>
          Enstrüman kaydında oda tonu enstrümana göre değişir. Davul ve gitar farklı yansıma karakteri
          üretir. Yumurta panel bu yansımaları kontrol altına alır. Mikrofon yerleşimi de kayıt kalitesini
          etkiler. Doğru panel yerleşimi ile temiz kayıt elde edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Podcast ve yayın stüdyoları</h3>
        <p className={styles.seoText}>
          Podcast ve radyo yayın stüdyolarında küçük hacimde bile yankı kayıt kalitesini düşürür.
          Konuşmacının arkasına ve yan duvarlara yumurta sünger yerleştirmek çoğu durumda yeterlidir.
          Küçük odalarda yüzde 25-35 kaplama oranı önerilir.
        </p>
        <p className={styles.seoText}>
          Kendinden yapışkanlı modeller ev stüdyolarında hızlı kurulum sağlar. Mikrofonun yakaladığı oda
          tonu kayıt kalitesini doğrudan etkiler. Ev ofisinde masa arkasına bir panel yeterli olabilir.
          YouTube ve içerik üreticileri yumurta profili kamera önünde estetik görünüm için tercih eder.
        </p>
        <p className={styles.seoText}>
          Yayın stüdyolarında tavan yüksekliği düşükse tavan paneli de eklenmelidir. Halı ve perde
          yansımayı azaltır ancak sünger kadar etkili değildir. İkisini birlikte kullanmak en iyi sonucu
          verir. Ev stüdyosunda bütçe sınırlıysa önce arka duvar kaplanır.
        </p>

        <h3 className={styles.seoSubtitle}>Ev sinema odaları</h3>
        <p className={styles.seoText}>
          Ev sinema odasında hoparlör sesi duvar ve tavandan yansır. Yumurta sünger yan ve arka duvar
          uygulamasıyla surround kanalların netliği artar. Koyu renkli paneller ışık yansımasını azaltır.
          Film deneyimi belirgin şekilde iyileşir.
        </p>
        <p className={styles.seoText}>
          Subwoofer köşelerinde bas birikimi oluşur. Köşeye kalın bass trap eklemek gerekir. Yumurta duvar
          paneli ve köşe bass trap birlikte kullanılır.{' '}
          <Link to="/akustik-duz-sunger" rel="follow">
            Düz akustik sünger
          </Link>{' '}
          sade görünüm isteyen sinema odalarında alternatif olabilir.
        </p>
        <p className={styles.seoText}>
          Ön hoparlörlerin ilk yansıma noktası yan duvarlardadır. Bu noktalara yumurta panel yerleştirmek
          surround deneyimini güçlendirir. Oturma pozisyonu belirlendikten sonra panel yerleşimi planlanır.
          Merkez kanal hoparlörünün arkasına da panel eklenmesi diyalog netliğini artırır. Düşük tavanlı
          odalarda tavan yansımaları da hedeflenmelidir.
        </p>

        <h3 className={styles.seoSubtitle}>Prova odaları</h3>
        <p className={styles.seoText}>
          Müzik prova odalarında yüksek ses seviyesi yankıyı artırır. Yumurta sünger duvarlara
          uygulanarak içerideki ses kalitesi iyileştirilir. Dışarı ses gitmesini engellemez. Komşu
          şikayeti varsa duvar yalıtımı ayrıca planlanmalıdır.
        </p>
        <p className={styles.seoText}>
          Elektro gitar ve davul yüksek ses üretir. Duvar ince ise komşuya ses gider. Bu durumda duvar
          arkasına bondex sünger eklenmesi gerekir. İç akustik ve dış yalıtım birlikte düşünülmelidir.
        </p>
        <p className={styles.seoText}>
          Prova odasında genelde duvarların yüzde 40-50 si kaplanır. Elektro gitar ve davul yüksek ses
          üretir. Yumurta panel bu sesi odada tutar ve yankıyı azaltır. Komşu şikayeti varsa duvar
          yalıtımı ayrıca planlanmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Ofis ve çalışma alanları</h3>
        <p className={styles.seoText}>
          Ev ofisi ve küçük çalışma odalarında yumurta sünger yankıyı azaltır. Video konferans yapılan
          alanlarda karşı taraf temiz ses alır. Açık ofiste tavan panelleri daha yaygındır ancak kişisel
          çalışma kabinlerinde duvar uygulaması tercih edilir.
        </p>
        <p className={styles.seoText}>
          Çağrı merkezi ve küçük toplantı odalarında konuşma netliği artar. Yangın sertifikalı ürünler
          kurumsal projelerde tercih edilir. Yumurta profil ofis ortamında piramide göre daha yumuşak
          görünüm sunar.
        </p>
        <p className={styles.seoText}>
          Küçük toplantı odalarında yumurta panel konuşma gizliliğini artırır. Cam bölmeli odalarda ses
          cam yüzeyden yansır. Duvar uygulaması yankıyı kontrol altına alır. Kurumsal projelerde yangın
          sertifikası zorunlu tutulur.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Süngerin Avantajları Nelerdir?</h2>

        <h3 className={styles.seoSubtitle}>Yankının azaltılmasına katkı sağlaması</h3>
        <p className={styles.seoText}>
          Yumurta profilli yüzey reverberasyon süresini kısaltır. Boş odada konuşma veya müzik yansıyarak
          çınlama yapar. Sünger paneller bu yansımaları emdiğinde ortam daha kontrollü ses verir. RT60
          değeri kısaldığında gürültü algısı düşer.
        </p>
        <p className={styles.seoText}>
          Stüdyo kayıtlarında yankısız ortam elde etmek bu avantajla mümkün olur. Podcast kayıtlarında
          oda tonu düşer. Toplantı odasında konuşma netliği artar.
        </p>

        <h3 className={styles.seoSubtitle}>Daha net ses elde edilmesine yardımcı olması</h3>
        <p className={styles.seoText}>
          Yankı azaldığında vokal kayıtları daha temiz çıkar. Enstrüman kayıtlarında oda tonu kontrol
          altına alınır. Video konferansta karşı taraf temiz ses alır. Müzik prodüksiyonunda miks
          kararları daha güvenilir verilir.
        </p>
        <p className={styles.seoText}>
          Konuşma odalarında heceler birbirine karışmaz. Herkes birbirini daha net duyar. Eğitim
          ortamında öğretmenin sesi öğrencilere daha net ulaşır.
        </p>

        <h3 className={styles.seoSubtitle}>Estetik ve düzenli görünüm sunması</h3>
        <p className={styles.seoText}>
          Yumurta desen düzenli ve yumuşak bir görünüm oluşturur. Piramit profil daha keskin, yumurta daha
          yuvarlak hatlıdır. Stüdyo ve podcast odalarında kamera önünde profesyonel görünüm sağlar.
          Siyah ve koyu gri tonlar çoğu dekorasyonla uyumludur.
        </p>
        <p className={styles.seoText}>
          Ev müzik odasında yumurta profil daha sıcak bir atmosfer yaratır. Kurumsal ortamlarda da modern
          görünüm sunar. Estetik kaygısı olan projelerde yumurta sık tercih edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Hafif ve kolay monte edilebilmesi</h3>
        <p className={styles.seoText}>
          Yumurta akustik sünger hafiftir. Tek kişi paneli kaldırıp duvara yapıştırabilir. Maket bıçağı
          ile kolay kesilir. Kendinden yapışkanlı modeller hızlı kurulum sağlar. Özel şekil ve köşe
          detayları hızlıca hazırlanır.
        </p>
        <p className={styles.seoText}>
          Yangına dayanıklıdır ve toz tutmaz yapıdadır. Uzun vadede bakım maliyeti düşüktür. Düzgün
          montajda panel düşmesi yaşanmaz. Ev kullanıcısı bir öğleden sonra küçük bir odayı düzenleyebilir.
        </p>
        <p className={styles.seoText}>
          Yumurta sünger nem ve rutubete karşı dayanıklıdır. Bodrum katı müzik odasında uygun yapıştırıcı
          ile sorunsuz çalışır. Uzun vadede bakım gerektirmez. Periyodik toz alma performansı korur.
          Panel değişimi yalnızca fiziksel hasar durumunda gerekir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Ölçüleri</h2>

        <h3 className={styles.seoSubtitle}>Standart ebat seçenekleri</h3>
        <p className={styles.seoText}>
          Standart plaka ölçüsü 100x100 cm dir. Bu ebat kargo ve montaj açısından pratiktir. 50x50 cm
          yarım plaka küçük alanlar için kullanılır. Sipariş öncesi duvar veya tavan metrajı hesaplanmalıdır.
          Teknik ekibimiz çizim üzerinden panel adedi hesaplar.
        </p>
        <p className={styles.seoText}>
          100x100 cm plaka 1 metrekare alan kaplar. Duvar yüksekliği 2.50 m ise dikeyde 2.5 panel gerekir.
          Pencere ve kapı boşlukları hesaptan düşülür. Fazla panel stokta kalır, eksik panel montajı
          geciktirir. Sipariş öncesi net metraj paylaşıldığında kesim listesi aynı gün hazırlanır.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlık alternatifleri</h3>
        <p className={styles.seoText}>
          20 mm hafif yankı kontrolü için uygundur. 30 mm ev ve ofis projelerinde en çok satılan
          kalınlıktır. 40 mm stüdyo ve sinema odalarında tercih edilir. 50 mm yüksek performans ve bass
          trap uygulamalarında kullanılır.
        </p>
        <p className={styles.seoText}>
          Küçük odada 50 mm paneller boğuk ses üretebilir. 15 m² altı odalarda 20-30 mm yeterli olabilir.
          40 m² ve üzeri odalarda 40-50 mm daha dengeli çalışır.
        </p>
        <p className={styles.seoText}>
          Kalınlık seçiminde oda hacmi kadar kullanım amacı da belirleyicidir. Vokal kayıt odasında 30 mm
          çoğu durumda yeterlidir. Davul ve bas gitar kaydında 40-50 mm tercih edilir. Tavan uygulamasında
          yerçekimi etkisi nedeniyle 30 mm üzeri kalınlık daha güvenli sabitlenir. İnce panel tavanda
          zamanla gevşeme riski taşır.
        </p>

        <h3 className={styles.seoSubtitle}>İhtiyaca özel üretim seçenekleri</h3>
        <p className={styles.seoText}>
          Standart ölçü dışında proje bazlı kesim yapıyoruz. Eğri duvar ve tavan kasası gibi özel detaylar
          için CNC kesim hizmeti sunulur. Teknik çizim paylaşıldığında kesim listesi aynı gün hazırlanır.
          Büyük stüdyo projelerinde farklı duvarlara farklı kalınlık uygulanabilir.
        </p>
        <p className={styles.seoText}>
          Özel üretim taleplerinde proje çizimleri paylaşılmalıdır. Numune gönderimi büyük siparişlerde
          talep edilebilir. Onay sonrası toplu üretim başlar. Büyük projelerde parti parti teslimat
          planlanabilir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Seçerken Nelere Dikkat Edilmelidir?</h2>

        <h3 className={styles.seoSubtitle}>Kullanım alanına uygun kalınlık seçimi</h3>
        <p className={styles.seoText}>
          Podcast odası ile müzik stüdyosu aynı kalınlığı gerektirmez. Küçük odada ince panel yeterli
          olabilir. Stüdyo kayıt odasında 40-50 mm tercih edilir. Yanlış kalınlık ya yetersiz performans
          ya da boğuk ses üretir.
        </p>
        <p className={styles.seoText}>
          Ev ofisinde 20 mm panel masa arkasına yerleştirildiğinde video konferans kalitesi artar. Müzik
          stüdyosunda kontrol odası ile kayıt odası farklı kalınlık gerektirebilir. Kontrol odasında
          dengeli akustik için 30-40 mm yeterlidir. Kayıt odasında 40-50 mm daha agresif emilim sağlar.
          Teknik ekibimiz oda ölçülerinizi paylaştığınızda kalınlık önerisi sunar.
        </p>

        <h3 className={styles.seoSubtitle}>Sünger yoğunluğunun önemi</h3>
        <p className={styles.seoText}>
          Yoğunluk kg/m³ cinsinden ifade edilir. Yüksek yoğunluklu sünger daha dayanıklıdır ve düşük
          frekanslarda daha iyi çalışır. Profesyonel projelerde 25-35 kg/m³ aralığı yaygındır. Bass trap
          uygulamalarında daha yüksek yoğunluk gerekir.
        </p>

        <h3 className={styles.seoSubtitle}>Kaplanacak alanın doğru hesaplanması</h3>
        <p className={styles.seoText}>
          Oda hacmi kaplama oranını belirler. Küçük podcast odasında yüzde 25-30 kaplama yeterli olabilir.
          Stüdyoda yüzde 40-50 gerekebilir. Metrekare hesabında tavan dahil edilmelidir. Teknik ekibimiz
          ücretsiz metraj hesabı yapar.
        </p>
        <p className={styles.seoText}>
          Kaplama oranı tüm yüzeyi kapsamak zorunda değildir. İlk yansıma noktaları ve arka duvar öncelik
          alır. Küçük odada tüm duvarı kaplamak boğuk ses üretebilir. Büyük stüdyoda yüzde 50 kaplama
          dengeli sonuç verir. Tavan alanı duvar alanından küçük olsa da yansıma kaynağıdır. Tavan
          kaplaması atlanmamalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Uygulama yapılacak yüzeyin durumu</h3>
        <p className={styles.seoText}>
          Yüzey temiz, kuru ve düzgün olmalıdır. Nemli yüzeylerde önce kurutma yapılmalıdır. Alçıpan, beton
          ve ahşap yüzeylere uygulanır. Tavan uygulamasında geçici destek gerekebilir. Dış cepheye bakan
          duvarlarda güneş ışığı solmaya neden olabilir.
        </p>
        <p className={styles.seoText}>
          Fiyat karşılaştırması yapılırken yalnızca birim fiyata bakmak yanıltıcı olabilir. Yanlış
          kalınlık seçimi yeniden sipariş gerektirir. Doğru ürün seçimi baştan yapıldığında yumurta akustik
          sünger uzun vadede ekonomik bir yatırımdır. WhatsApp hattımızdan anında teklif alabilirsiniz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Nasıl Uygulanır?</h2>

        <h3 className={styles.seoSubtitle}>Montaj öncesi hazırlık</h3>
        <p className={styles.seoText}>
          Yüzey temiz, kuru ve tozdan arındırılmış olmalıdır. Gevşek boya yapışmayı zayıflatır. Montaj
          planı çizilerek panel yerleşimi önceden belirlenir. İlk yansıma noktaları işaretlenir.
        </p>
        <p className={styles.seoText}>
          Oda içindeki mobilya montaj öncesi çekilmelidir. Halı ve perde geçici olarak kaldırılabilir.
          Elektrik prizleri ve anahtarlar panel kesiminde dikkate alınır. Maket bıçağı ile priz çevresi
          temiz kesilir. Montaj sırasında oda havalandırılmalıdır. Yapıştırıcı kokusu birkaç saat içinde
          dağılır.
        </p>

        <h3 className={styles.seoSubtitle}>Yapıştırıcı seçimi</h3>
        <p className={styles.seoText}>
          Yumurta akustik sünger için solvent içermeyen özel yapıştırıcı kullanılır. Solvent bazlı
          yapıştırıcılar süngeri eritebilir. Sprey yapıştırıcı büyük alanlarda pratiktir. Kendinden
          yapışkanlı modellerde arka yüz koruma bandı kaldırılarak yapıştırılır.
        </p>

        <h3 className={styles.seoSubtitle}>Panellerin doğru yerleştirilmesi</h3>
        <p className={styles.seoText}>
          Tüm yüzeyi kaplamak her zaman doğru değildir. Hoparlör veya konuşmacı hizasındaki ilk yansıma
          noktaları önceliklidir. Arka duvar hedeflenir. Dengeli kaplama ilkesi her projede geçerlidir.
          Stüdyolarda mirror point hesabı yapılır.
        </p>
        <p className={styles.seoText}>
          Yapıştırıcı hem süngere hem duvara sürülür. 30 saniye bekledikten sonra panel bastırılır.
          Köşe birleşimlerinde bass trap düşük frekans performansını artırır. Montaj sonrası oda akustiği
          hemen fark edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Uygulama sonrası dikkat edilmesi gerekenler</h3>
        <p className={styles.seoText}>
          Paneller arasında 2-5 mm boşluk bırakmak genleşmeye izin verir. Tavan uygulamasında geçici bant
          kullanılır. Montaj sonrası oda akustiği kulağa hemen fark edilir. Echopan montaj kılavuzu
          siparişle birlikte gönderilir. WhatsApp hattımızdan montaj desteği alınabilir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Fiyatlarını Etkileyen Faktörler</h2>
        <p className={styles.seoText}>
          Akustik yumurta sünger fiyatı metrekare başına 320 TL dir. Aşağıdaki unsurlar toplam maliyeti
          etkiler. Teklif almak için kalınlık, metraj ve teslimat adresi paylaşılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlık</h3>
        <p className={styles.seoText}>
          Kalınlık arttıkça birim maliyet yükselir. 20 mm en ekonomik giriş seviyesidir. 50 mm en yüksek
          birim fiyatlı standart kalınlıktır.           Doğru kalınlık seçimi gereksiz harcamayı önler.
        </p>
        <p className={styles.seoText}>
          20 mm panel metrekare başına en düşük malzeme maliyetini sunar. Ancak yetersiz kalınlık yeniden
          siparişe yol açar. 30 mm fiyat ve performans dengesi açısından en çok tercih edilen kalınlıktır.
          50 mm birim maliyeti yüksektir ancak stüdyo projelerinde tek seferde doğru çözüm sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Yoğunluk</h3>
        <p className={styles.seoText}>
          Yüksek yoğunluklu sünger birim fiyatı artırır. Profesyonel stüdyo projelerinde yüksek yoğunluk
          tercih edilir. Konut uygulamalarında standart yoğunluk yeterli olabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Sipariş miktarı</h3>
        <p className={styles.seoText}>
          Büyük metrajlı siparişlerde birim fiyat avantajı sağlanabilir. Tek plaka siparişi de kabul
          edilir. Kurumsal projelerde parti parti teslimat planlanabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Özel üretim talepleri</h3>
        <p className={styles.seoText}>
          Özel kesim ve kendinden yapışkanlı yüzey birim maliyeti etkiler. CNC kesimli özel parçalar
          standart plakadan farklı fiyatlanır.{' '}
          <Link to="/akustik-sunger" rel="follow">
            Akustik sünger
          </Link>{' '}
          ana sayfamızdan diğer profil ve fiyat bilgilerine ulaşabilirsiniz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Yumurta Sünger Hakkında Sık Sorulan Sorular</h2>

        <h3 className={styles.seoSubtitle}>Akustik yumurta sünger sesi tamamen keser mi?</h3>
        <p className={styles.seoText}>
          Hayır. Akustik yumurta sünger oda içindeki yankıyı azaltır, sesi kesmez. Komşu duvarından gelen
          sesi engellemek için bondex veya bariyerli bondex kullanılmalıdır.
        </p>
        <p className={styles.seoText}>
          Yumurta sünger oda içi akustik düzenleme ürünüdür. Duvar arkasına serildiğinde komşu sesi
          kesmez. Ses geçişi ile yankı kontrolü farklı ihtiyaçlara karşılık verir. Aynı projede ikisi
          birlikte kullanılabilir. Önce yankı sorunu çözülür, ardından gerekirse duvar yalıtımı planlanır.
        </p>

        <h3 className={styles.seoSubtitle}>Ev kullanımına uygun mudur?</h3>
        <p className={styles.seoText}>
          Ev sinema odası, müzik odası ve podcast köşesinde güvenle kullanılır. Yangına dayanıklı E sınıfı
          modellerimiz konut uygulamalarına uygundur.
        </p>
        <p className={styles.seoText}>
          Ev müzik odasında bir duvar kaplaması bile fark yaratır. Kendinden yapışkanlı modeller kiracılar
          için idealdir. Söküldüğünde duvar yüzeyinde iz bırakmaz. Çocuk odasında müzik çalışması yapılan
          alanlarda yankı azaltılır. Yangın sertifikalı ürün güvenli kullanım sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Tavan uygulamalarında kullanılabilir mi?</h3>
        <p className={styles.seoText}>
          Tavanda kullanılabilir. Hafif paneller yapıştırıcı ile sabitlenir. Büyük plakalarda geçici destek
          önerilir.           Tavan uygulamasında yerleşim planı önemlidir.
        </p>
        <p className={styles.seoText}>
          Tavan paneli hoparlör veya mikrofon hizasına yerleştirilir. Büyük plakalarda montaj sırasında
          geçici bant ile desteklenir. Yapıştırıcı kuruduktan sonra bant kaldırılır. Tavan yüksekliği 2.20
          m altındaysa tavan kaplaması öncelik kazanır. Düşük tavanda yansıma sorunu daha belirgindir.
        </p>

        <h3 className={styles.seoSubtitle}>Yangına dayanıklı modeli var mı?</h3>
        <p className={styles.seoText}>
          Evet. Tüm yumurta akustik sünger modellerimiz TS EN 13501-1 standardına göre E sınıfı yanmazlık
          sertifikasına sahiptir. Okul ve ticari proje taleplerinde sertifika paylaşılır.
        </p>

        <h3 className={styles.seoSubtitle}>Temizliği nasıl yapılır?</h3>
        <p className={styles.seoText}>
          Yumuşak fırça veya elektrik süpürgesi ile toz alınır. Nemli bezle silmek mümkündür ancak aşırı
          su kullanmayın. Kimyasal temizleyici sünger yapısına zarar verebilir.
        </p>

        <h3 className={styles.seoSubtitle}>Kullanım ömrü ne kadardır?</h3>
        <p className={styles.seoText}>
          Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş
          ışığına maruz kalan yüzeylerde erken solma görülebilir. Fiziksel darbe yumurta çıkıntılarını
          ezerek emilimi düşürebilir.
        </p>
        <p className={styles.seoText}>
          Yumurta sünger ile ne kadar alan kaplanmalı sorusunun cevabı mekan boyutuna bağlıdır. Stüdyo
          ve kayıt odalarında duvar ve tavan alanının yaklaşık yüzde 30-50 si kaplanır. Podcast odasında
          yüzde 25-35 yeterli olabilir. Teknik ekibimizden metraj önerisi alabilirsiniz.
        </p>
      </section>
    </div>
  );
}
